<template>
    <div class="modal" tabindex="-1" role="dialog" ref="modalElement" id="ack_modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header"
                     :class="styleState.headerTitleStyle">

                    <h5 class="modal-title">{{ state.title }}</h5>
                    <button type="button" class="close"
                            @click="closeModal"
                            aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <p v-html="state.message"></p>
                </div>

                <div class="modal-footer justify-content-center">
                    <button type="button" class="btn "
                            :class="styleState.btnStyle"
                            @click="closeModal()">
                        Ok
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
/**
 *
 * Created by Filipe - 11/01/2021
 *
 */
import {computed, onMounted, reactive, ref, watch} from "vue";

import Modal from 'bootstrap/js/dist/modal'
import {useMainStore} from "@/stores/mainStore";


/**
 *
 * - AVAILABLE TYPES:
 *  success - green header
 *  danger - red header
 *  primary - blue header
 *  warn - yellow header
 *  info - info header
 *
 */
export default {
    name: "AckPopup",

    setup() {

        const mainStore = useMainStore();
        const modalElement = ref(null)

        const state = computed(() => mainStore.getAcknowledge)

        let myModal: Modal;

        const styleState = reactive({
            headerTitleStyle: computed(() => {
                const type = mainStore.getAcknowledge.type
                switch (type) {
                    case 'success':
                        return 'text-white bg-success'
                    case 'danger':
                        return 'text-white bg-danger'
                    case 'primary':
                        return 'text-white bg-primary'
                    case 'warn':
                        return 'text-white bg-warning'
                    case 'info':
                        return 'text-white bg-info'
                }
                return ''
            }),
            btnStyle: computed(() => {
                let btnStyle = mainStore.getAcknowledge.btnStyle
                if (!btnStyle) {
                    const type = mainStore.getAcknowledge.type
                    switch (type) {
                        case 'danger':
                            btnStyle = 'btn-danger'
                            break
                        case 'info':
                            btnStyle = 'btn-info'
                            break
                        case 'success':
                            btnStyle = 'btn-success'
                            break
                        case 'warn':
                            btnStyle = 'btn-warn'
                            break
                        default:
                            btnStyle = 'btn-primary'
                            break
                    }
                }
                return btnStyle
            }),
        })

        onMounted(() => {
            myModal = new Modal('#ack_modal', {
                keyboard: false
            })
            const element = document.getElementById('ack_modal');
            if (element) {
                element.addEventListener('hidden.bs.modal', () => {
                    mainStore.showAcknowledge();
                })
            }

        })

        watch(
            () => state.value.show,
            (show/*, prevShow*/) => {
                show ? myModal.show() : myModal.hide()
            }
        )

        function closeModal() {
            // console.debug('closeModal')
            mainStore.showAcknowledge();
        }


        return {
            modalElement,
            state,
            styleState,
            closeModal,
        }


    }
}
</script>

<style scoped>

</style>
